import useApi from "hooks/useApi";
import { useQuery } from "react-query";
import { handleAxiosError } from "./utils";

interface UseQueryOfferConfigurationProps {
  readonly marketplace: string;
  readonly merchantId: string;
  readonly asin: string;
  readonly sku: string;
  readonly fmId: string;
}

export interface OfferConfigurationResponse {
  enabled: boolean;
  status: string;
}

const OFFER_CONFIGURATION_ENDPOINT = "/offer-configuration";

export default function useQueryOfferConfiguration(requestParams: UseQueryOfferConfigurationProps) {
  const api = useApi();

  const fetchOfferConfiguration: () => Promise<OfferConfigurationResponse> = async () => {
    try {
      // TODO: IBA-CORE-2935 Refactor http verb to POST for this endpoint
      const { data }: { data: OfferConfigurationResponse } = await api.get(OFFER_CONFIGURATION_ENDPOINT, {
        params: requestParams,
      });

      return data;
    } catch (e) {
      return handleAxiosError(e);
    }
  };

  const queryKey = ["offerConfiguration", requestParams];
  return useQuery<OfferConfigurationResponse, string>(queryKey, fetchOfferConfiguration, { enabled: false });
}
